import { reqGetUserInfo } from '@/api'
const state = {
	// fix--start
	addFormNum: 0,
	refreshNum: 4, // 刷新次数
	invokeApiCount: 0, // 调用接口次数
	testCount: 0,
	// 考生全部信息
	userAllInfo: {},
	// fix--end

	// 考生信息
	examinee: {},
	total: []
};

const getters = {

	// fix--start
	GET_API_COUNT(state) {
	return state.invokeApiCount
	},
	GET_USER_INFO(state) { // get_user_info api
		return state.userAllInfo
	},
	// fix--end
	GET_EXAMINEE_INFO(state) { // aside_user_info api
		return state.examinee
	}
};

const mutations = {
	// fix--start
	// 设置api调用次数
	SET_REFRESH_NUM(state, data) {
		if(data) {
			state.refreshNum = data;
		} else {
			state.refreshNum++
		}
		console.log('refreshNum---->',state.refreshNum)
	},
	SET_ADD_FORM_NUM(state, data) {
		state.addFormNum = data;
	},
	SET_TOTAL(state, data) {
		state.total = data;
	},
	SET_API_COUNT(state, data) {
		if(data) {
			state.invokeApiCount = data;
		} else {
			if (state.addFormNum === 0 && state.invokeApiCount < 10) {
				state.invokeApiCount++
			} else {
				state.invokeApiCount = 0
			}
		}
		console.log('invokeApiCount---->',state.invokeApiCount)
	},
	// 设置考生的所有信息
	SET_USER_INFO(state, data) {
		state.userAllInfo = {
			...data
		}
	},
	// fix--end

	// 保存考生信息
	SET_EXAMINEE(state, data) {
		state.examinee = {
			...data
		};
	},
	// 保存考生姓名
	SET_NAME(state, name) {
		state.examinee = {
			...state.examinee,
			name
		};
	},
	// 保存考生ID
	SET_ID(state, id) {
		state.examinee = {
			...state.examinee,
			id
		};
	},
	// 保存考生报名序号
	SET_SERIAL_ID(state, serial_id) {
		state.examinee = {
			...state.examinee,
			serial_id
		};
	},
	// 保存考生行程填写状态
	SET_DO_TRAVEL(state, do_travel) {
		state.examinee = {
			...state.examinee,
			do_travel
		};
	},

};

const actions = {
	setUserInfo({commit,state}) {
		if (state.invokeApiCount !== 0) { // temp
			commit('SET_API_COUNT')
		} else {
			reqGetUserInfo().then(res => {
				if (res.code === 200) {
					commit('SET_USER_INFO',res.data)
					commit('SET_API_COUNT')
				}
			})
		}
	},
	resetUserInfo({commit,state}) {
		reqGetUserInfo().then(res => {
			if (res.code === 200) {
				commit('SET_USER_INFO',res.data)
			}
		})
	},
	resetRefreshNum({commit,state}) {
		commit('SET_REFRESH_NUM')
	}
}

export default {
	namespaced: true,
	state,
	getters,
	mutations,
	actions
}
